
<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
  <p-tabPanel header="App Configuration"></p-tabPanel>
  @if (role !== roles.enduser && role !== roles.installer) {
    <p-tabPanel header="User Management"></p-tabPanel>
  }
  <p-tabPanel header="Group Management"></p-tabPanel>
  @if(role == roles.enduser || role == roles.installer) {
    <p-tabPanel header="Device Access Management"></p-tabPanel>
  }
  
</p-tabView>

<router-outlet></router-outlet>
